
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_810_707)","stroke":"#535353","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13 6H9V2M14 1L9 6M2 9h4v4M6 9l-5 5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_810_707"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    